var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useDeleteRecordsMutation } from "@/store/api";
import toast from "react-hot-toast";
import { faCaretDown, faMerge, faPen, faTrash, } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useState } from "react";
import { usePopup } from "@/hooks/layout";
import { useNavigate } from "react-router-dom";
import { Checkbox, Dropdown, Menu, MenuButton, MenuItem } from "@mui/joy";
import React from "react";
import { useTranslation } from "react-i18next";
var massupdate = function Massupdate(_a) {
    var _this = this;
    var recordId = _a.recordId, module = _a.module, rowCheckedCount = _a.rowCheckedCount, selectedDesc = _a.selectedDesc, isLoading = _a.isLoading, isDeleted = _a.isDeleted, unCheck = _a.unCheck, checkPage = _a.checkPage, checkAll = _a.checkAll, rowsPerPage = _a.rowsPerPage, allRows = _a.allRows, isChecked = _a.isChecked, massUpdateFields = _a.massUpdateFields, isMassupdated = _a.isMassupdated, isLoadOnEditing = _a.isLoadOnEditing;
    // Delete id
    var deleteRecordsMutaion = useDeleteRecordsMutation()[0];
    var _b = useState(false), load = _b[0], setLoad = _b[1];
    var t = useTranslation(["common"]).t;
    var deleteRecords = function () { return __awaiter(_this, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    isLoading(load);
                    return [4 /*yield*/, deleteRecordsMutaion({
                            moduleName: module,
                            body: recordId || [],
                        }).unwrap()];
                case 1:
                    result = _a.sent();
                    toast.success("Enregistrements supprimés");
                    isDeleted(1);
                    setLoad(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    isDeleted(0);
                    setLoad(false);
                    console.log(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // Action en masse : hover
    var _c = useState(false), isHovering = _c[0], setIsHovering = _c[1];
    var _d = useState(false), isFusionHovering = _d[0], setIsFusionHovering = _d[1];
    var _e = useState(false), isDeleteHovering = _e[0], setIsDeleteHovering = _e[1];
    var handleMouseOver = function () {
        setIsHovering(true);
    };
    var handleMouseOut = function () {
        setIsHovering(false);
    };
    var handleFusionMouseOver = function () {
        setIsFusionHovering(true);
    };
    var handleFusionMouseOut = function () {
        setIsFusionHovering(false);
    };
    var handleDeleteMouseOver = function () {
        setIsDeleteHovering(true);
    };
    var handleDeleteMouseOut = function () {
        setIsDeleteHovering(false);
    };
    var _f = usePopup(), showPopup = _f.showPopup, closePopup = _f.closePopup;
    var deleteConfirm = function () { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, showPopup({
                        type: "dev/popup/confirm",
                        payload: {
                            title: t("app.LBL_MASSUPDATE_DELETE_CONFIRM") +
                                rowCheckedCount +
                                t("app.LBL_MASSUPDATE_DELETE_CONFIRM1"),
                            content: " ",
                            buttons: {
                                confirm: t("app.LBL_MASSUPDATE_DELETE_YES"),
                                cancel: t("app.LBL_MASSUPDATE_DELETE_NO"),
                            },
                        },
                    })];
                case 1:
                    result = _a.sent();
                    if ((result === null || result === void 0 ? void 0 : result.reason) === "confirm") {
                        deleteRecords();
                        closePopup("null", "null");
                        setLoad(true);
                    }
                    else {
                        closePopup("null", "null");
                        setLoad(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var navigate = useNavigate();
    var handleClose = function () {
        return;
    };
    var handleCloseUnselect = function () {
        unCheck(true);
    };
    var handleCloseCheckPage = function () {
        checkPage(true);
    };
    var handleCloseCheckAll = function () {
        checkAll(true);
    };
    var _g = useState(false), open = _g[0], setOpen = _g[1];
    var handleOpenChange = useCallback(function (event, isOpen) {
        setOpen(isOpen);
    }, []);
    function handleChangemultiple(e) {
        e.target.checked ? checkPage(true) : unCheck(true);
    }
    var handleSubmission = function (d) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            isMassupdated(d);
            return [2 /*return*/];
        });
    }); };
    var handleLoading = function (isLoaded) {
        isLoadOnEditing(isLoaded);
    };
    var editLine = function () { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, showPopup({
                        type: "widget/massupdate",
                        //slot: Slot.DOCK_EAST,
                        payload: {
                            title: "MASS UPDATE",
                            module: module,
                            recordId: recordId,
                            massUpdateFields: massUpdateFields,
                            content: recordId,
                            onSubmit: handleSubmission,
                            isLoading: handleLoading,
                            buttons: {
                                confirm: "save",
                                cancel: "cancel",
                            },
                        },
                    })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", { children: rowsPerPage && rowsPerPage > 0 ? (_jsxs("div", __assign({ className: "flex items-center ml-[12px]" }, { children: [_jsx(Checkbox, { onChange: handleChangemultiple, className: "pl-1", color: "neutral", checked: isChecked }), _jsxs("span", __assign({ className: "text-[var(--colors-label)] pr-2 hover:bg-gray-200  rounded-md" }, { children: [_jsxs(Dropdown, __assign({ open: open, onOpenChange: handleOpenChange }, { children: [_jsx(MenuButton, __assign({ variant: "soft", sx: {
                                        "&:hover": {
                                            color: "gray",
                                            background: "none",
                                        },
                                        border: "none",
                                        background: "none",
                                    } }, { children: _jsx(FontAwesomeIcon, { className: "text-gray-500 border-none", icon: faCaretDown }) })), _jsxs(Menu, __assign({ placement: "bottom-start", className: "overflow-y-auto overflow-x-hidden max-h-[80vh]" }, { children: [_jsxs(MenuItem, __assign({ onClick: handleCloseCheckPage }, { children: [t("app.LBL_SELECT_ALL_PAGE"), " (", rowsPerPage, " ", t("app.LBL_ROWS"), ")"] })), _jsxs(MenuItem, __assign({ onClick: handleCloseCheckAll }, { children: [t("app.LBL_SELECT_ALL_RESULT"), " (", allRows, " ", t("app.LBL_ROWS"), ")"] })), _jsx(MenuItem, __assign({ onClick: handleCloseUnselect }, { children: t("app.LBL_UNSELECT_ALL") }))] }))] })), rowCheckedCount, " ", selectedDesc] })), rowCheckedCount > 0 && (_jsxs(_Fragment, { children: [_jsxs("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md", onMouseOver: handleDeleteMouseOver, onMouseOut: handleDeleteMouseOut, onClick: deleteConfirm }, { children: [_jsx(FontAwesomeIcon, { icon: faTrash, className: "text-gray-400 px-2 dark:text-black" }), isDeleteHovering && (_jsx("label", __assign({ className: "text-gray-400 px-1" }, { children: String(t("app.LBL_DELETE_BUTTON", { ns: "common" })) })))] })), rowCheckedCount >= 2 && rowCheckedCount < 5 && (_jsxs("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md dark:bg-[rgb(var(--color-gray-200))]", onMouseOver: handleFusionMouseOver, onMouseOut: handleFusionMouseOut, onClick: function () {
                                navigate("/modules/".concat(module, "/Merge"), {
                                    state: { ids: recordId },
                                });
                            } }, { children: [_jsx(FontAwesomeIcon, { icon: faMerge, className: "text-gray-400 px-2 dark:text-black" }), isFusionHovering && (_jsx("label", __assign({ className: "text-gray-400 px-1" }, { children: String(t("app.LBL_MERGE_DUPLICATES", { ns: "common" })) })))] }))), _jsxs("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md", onMouseOver: handleMouseOver, onMouseOut: handleMouseOut, onClick: editLine }, { children: [_jsx(FontAwesomeIcon, { icon: faPen, className: "text-gray-400 pl-2 dark:text-black" }), isHovering && (_jsx("label", __assign({ className: "text-gray-400 px-2" }, { children: String(t("app.LBL_EDIT_BUTTON", { ns: "common" })) })))] }))] }))] }))) : (String(t("app.LBL_NO_DATA"))) }));
};
export default React.memo(massupdate);
